export const comics = [
  {
    id: "1",
    title: "秘密课堂",
    slug: "secret-class",
    author: "王正道",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20romance%20drama%20theme%2C%20young%20couple%20in%20school%20uniform%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20style%20with%20delicate%20linework%2C%20pastel%20pink%20and%20cream%20background%2C%20emotional%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20high%20quality%202D%20digital%20art&width=800&height=1100&seq=comic-cover-01&orientation=portrait",
    category: "恋爱",
    tags: ["恋爱", "校园", "日常"],
    latestChapter: 128,
    updateTime: "2026-07-03",
    status: "连载中",
    rating: 9.6,
    views: "1280万",
    description: "一位普通的高中生意外发现了班主任的秘密，从此他的人生轨迹发生了翻天覆地的变化。在这个充满青春荷尔蒙的校园里，一段禁忌又甜蜜的故事悄然展开。每周三、六更新，不容错过。",
    chapters: Array.from({ length: 128 }, (_, i) => ({
      number: 128 - i,
      title: `第${128 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 4) % 6).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`
    }))
  },
  {
    id: "2",
    title: "女神降临",
    slug: "goddess-descent",
    author: "猫咪",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20glamorous%20style%2C%20fashion%20beauty%20theme%2C%20soft%20peach%20and%20cream%20background%2C%20delicate%20illustration%20with%20elegant%20details%2C%20warm%20lighting%2C%20romantic%20comedy%20vibe%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-02&orientation=portrait",
    category: "恋爱",
    tags: ["恋爱", "校园", "美妆"],
    latestChapter: 256,
    updateTime: "2026-07-02",
    status: "连载中",
    rating: 9.8,
    views: "3560万",
    description: "因为长相平凡而饱受欺凌的女孩，通过化妆技巧华丽变身成为校园女神。然而美丽的外表下，她依然要面对真实的自己与虚假光环之间的挣扎。一部关于自信、成长与真爱的治愈系漫画。",
    chapters: Array.from({ length: 256 }, (_, i) => ({
      number: 256 - i,
      title: `第${256 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 5) % 6).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`
    }))
  },
  {
    id: "3",
    title: "剑尊归来",
    slug: "sword-master-return",
    author: "REDICE STUDIO",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20fantasy%20action%20theme%2C%20swordsman%20with%20flowing%20robe%20and%20long%20sword%2C%20dramatic%20pose%2C%20dark%20atmospheric%20background%20with%20moonlight%2C%20epic%20fantasy%20style%20illustration%2C%20dynamic%20composition%2C%20warm%20golden%20accents%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-03&orientation=portrait",
    category: "奇幻",
    tags: ["奇幻", "武侠", "重生"],
    latestChapter: 189,
    updateTime: "2026-07-03",
    status: "连载中",
    rating: 9.5,
    views: "2150万",
    description: "一代剑尊在巅峰之战中陨落，却意外重生回到少年时代。带着前世的记忆与绝世剑法，他要改写命运，踏上一条截然不同的霸者之路。热血沸腾的武侠奇幻巨作。",
    chapters: Array.from({ length: 189 }, (_, i) => ({
      number: 189 - i,
      title: `第${189 - i}话`,
      updateTime: `2026-${String(6 - Math.floor(i / 4) % 5).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`
    }))
  },
  {
    id: "4",
    title: "社内恋爱",
    slug: "office-romance",
    author: "朴泰俊",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20office%20romance%20theme%2C%20handsome%20man%20in%20suit%20and%20elegant%20woman%2C%20modern%20office%20setting%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20style%2C%20mature%20romance%20aesthetic%2C%20cream%20and%20beige%20background%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-04&orientation=portrait",
    category: "恋爱",
    tags: ["恋爱", "职场", "成人"],
    latestChapter: 95,
    updateTime: "2026-07-01",
    status: "连载中",
    rating: 9.3,
    views: "890万",
    description: "在首尔最顶尖的广告公司里，两个竞争对手被迫合作一个重大项目。从针锋相对到暗生情愫，办公室里的秘密恋情在利益与感情之间究竟该如何抉择？成人向职场恋爱漫画。",
    chapters: Array.from({ length: 95 }, (_, i) => ({
      number: 95 - i,
      title: `第${95 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 3) % 6).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`
    }))
  },
  {
    id: "5",
    title: "重生之都市修仙",
    slug: "urban-cultivation",
    author: "狂热工作室",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20urban%20cultivation%20fantasy%20theme%2C%20powerful%20protagonist%20with%20energy%20aura%2C%20modern%20city%20background%2C%20martial%20arts%20fantasy%20style%2C%20dramatic%20dynamic%20composition%2C%20warm%20golden%20and%20crimson%20accents%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-05&orientation=portrait",
    category: "奇幻",
    tags: ["奇幻", "修仙", "都市"],
    latestChapter: 312,
    updateTime: "2026-07-03",
    status: "连载中",
    rating: 9.7,
    views: "4280万",
    description: "修仙界第一强者渡劫失败，灵魂穿越到现代都市一个普通高中生身上。在这个灵气稀薄的世界里，他凭借前世的修仙经验，从零开始重新踏上巅峰之路。",
    chapters: Array.from({ length: 312 }, (_, i) => ({
      number: 312 - i,
      title: `第${312 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 6) % 6).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`
    }))
  },
  {
    id: "6",
    title: "甜蜜的陷阱",
    slug: "sweet-trap",
    author: "李贤秀",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20thriller%20romance%20theme%2C%20mysterious%20woman%20with%20intense%20gaze%2C%20dark%20elegant%20atmosphere%2C%20suspenseful%20mood%2C%20dramatic%20lighting%20with%20shadows%2C%20mature%20illustration%20style%2C%20deep%20burgundy%20and%20cream%20background%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-06&orientation=portrait",
    category: "悬疑",
    tags: ["悬疑", "恋爱", "惊悚"],
    latestChapter: 67,
    updateTime: "2026-07-02",
    status: "连载中",
    rating: 9.4,
    views: "670万",
    description: "一位美丽的女子出现在三个男人面前，每个人都以为自己是她唯一的爱人。当谎言被揭穿，一场惊心动魄的复仇游戏才刚刚开始。反转不断的悬疑恋爱漫画。",
    chapters: Array.from({ length: 67 }, (_, i) => ({
      number: 67 - i,
      title: `第${67 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 3) % 6).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`
    }))
  },
  {
    id: "7",
    title: "全知读者视角",
    slug: "omniscient-reader",
    author: "sing N song",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20apocalyptic%20fantasy%20theme%2C%20male%20protagonist%20with%20determined%20expression%2C%20dystopian%20cityscape%20background%2C%20epic%20fantasy%20style%2C%20dramatic%20composition%20with%20cinematic%20lighting%2C%20warm%20golden%20and%20dark%20tones%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-07&orientation=portrait",
    category: "奇幻",
    tags: ["奇幻", "末世", "系统"],
    latestChapter: 245,
    updateTime: "2026-07-02",
    status: "连载中",
    rating: 9.9,
    views: "5120万",
    description: "平凡上班族金独子是唯一一个读完连载十年的网络小说《在灭亡的世界中生存的三种方法》的人。当小说中的世界成为现实，他凭借着对剧情的了解，在这个末日世界里展开了一场惊心动魄的生存之旅。",
    chapters: Array.from({ length: 245 }, (_, i) => ({
      number: 245 - i,
      title: `第${245 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 5) % 6).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`
    }))
  },
  {
    id: "8",
    title: "恶女的定义",
    slug: "villainess-definition",
    author: "金恩淑",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20historical%20romance%20fantasy%20theme%2C%20elegant%20noblewoman%20in%20vintage%20dress%2C%20palace%20interior%20background%2C%20soft%20romantic%20atmosphere%2C%20delicate%20illustration%20with%20ornate%20details%2C%20warm%20golden%20and%20rose%20tones%2C%20high%20quality%20digital%20art&width=800&height=1100&seq=comic-cover-08&orientation=portrait",
    category: "恋爱",
    tags: ["恋爱", "古风", "穿越"],
    latestChapter: 156,
    updateTime: "2026-07-01",
    status: "连载中",
    rating: 9.2,
    views: "1560万",
    description: "现代女大学生穿越成为小说中注定悲惨死去的恶毒女配。为了改变命运，她决定远离主角们，低调做人。然而事与愿违，她的每一个善举都让剧情越来越偏离原著的轨迹...",
    chapters: Array.from({ length: 156 }, (_, i) => ({
      number: 156 - i,
      title: `第${156 - i}话`,
      updateTime: `2026-${String(6 - Math.floor(i / 4) % 5).padStart(2, '0')}-${String(28 - (i % 28)).padStart(2, '0')}`
    }))
  },
  {
    id: "9",
    title: "格斗实况",
    slug: "fight-live",
    author: "朴泰俊",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%2C%20action%20fighting%20theme%2C%20muscular%20fighter%20in%20dynamic%20combat%20pose%2C%20urban%20street%20background%2C%20intense%20energetic%20style%2C%20bold%20dynamic%20composition%2C%20warm%20orange%20and%20dark%20accents%2C%20high%20quality%20digital%20illustration&width=800&height=1100&seq=comic-cover-09&orientation=portrait",
    category: "热血",
    tags: ["热血", "格斗", "校园"],
    latestChapter: 203,
    updateTime: "2026-07-03",
    status: "连载中",
    rating: 9.6,
    views: "2980万",
    description: "瘦弱的高中生柳镇意外获得了一个神秘的格斗直播系统。每次格斗胜利都能获得点数来强化自身。从一个被霸凌的弱者到格斗之王，他用拳头打出了属于自己的传奇。",
    chapters: Array.from({ length: 203 }, (_, i) => ({
      number: 203 - i,
      title: `第${203 - i}话`,
      updateTime: `2026-${String(7 - Math.floor(i / 4) % 6).padStart(2, '0')}-${String(30 - (i % 30)).padStart(2, '0')}`
    }))
  }
];

export const categories = [
  { id: "romance", name: "恋爱", slug: "romance", count: 2860, description: "甜蜜浪漫的恋爱漫画，从校园到职场，从纯爱到成人向，总有一款适合你" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", count: 1950, description: "穿越异世界、修仙武侠、魔法冒险，精彩纷呈的奇幻世界等你探索" },
  { id: "action", name: "热血", slug: "action", count: 1680, description: "燃爆肾上腺素的热血格斗与战斗漫画，感受拳拳到肉的极致快感" },
  { id: "thriller", name: "悬疑", slug: "thriller", count: 920, description: "烧脑悬疑、惊悚推理，每一个分镜都暗藏玄机，让你欲罢不能" },
  { id: "comedy", name: "搞笑", slug: "comedy", count: 1340, description: "轻松搞笑的日常喜剧，治愈你的不开心，笑到停不下来" },
  { id: "bl", name: "BL", slug: "bl", count: 1560, description: "精选优质BL漫画，唯美细腻的画风，动人心弦的故事" },
];

export const stats = [
  { label: "漫画总量", value: "12,800+", icon: "ri-book-open-line" },
  { label: "日更新量", value: "200+", icon: "ri-refresh-line" },
  { label: "注册用户", value: "580万+", icon: "ri-user-line" },
  { label: "累计阅读", value: "36亿+", icon: "ri-eye-line" },
];

export const faqs = [
  {
    question: "韩漫大全漫画网的漫画都是免费的吗？",
    answer: "是的，我们平台所有漫画均提供免费下拉式阅读体验。您无需支付任何费用即可畅享海量韩漫资源，包括最新连载和无删减版本。我们通过广告收入维持平台运营，始终坚持以免费模式服务广大漫画爱好者。"
  },
  {
    question: "什么是在线下拉式阅读？",
    answer: "下拉式阅读是一种优化的网页漫画浏览方式，您只需向下滚动页面即可连续阅读漫画内容，无需翻页点击。这种方式特别适合手机端阅读，提供流畅无缝的阅读体验，让您沉浸在漫画世界中不被打断。"
  },
  {
    question: "漫画更新频率是怎样的？",
    answer: "我们拥有专业的翻译和更新团队，热门漫画通常与韩国原版保持同步更新，每周更新2-3话。一般漫画每周至少更新1话。您可以在每部漫画的详情页查看具体的更新日程，也可以通过订阅功能获取更新通知。"
  },
  {
    question: "如何查找我喜欢的漫画？",
    answer: "您可以通过首页的搜索框直接搜索漫画名称，也可以使用分类导航按类型浏览。我们还提供热门排行、最新更新和编辑推荐等多种发现方式，帮助您快速找到感兴趣的漫画作品。"
  },
  {
    question: "平台支持哪些设备阅读？",
    answer: "韩漫大全漫画网采用响应式设计，完美适配PC端、平板和手机等各种设备。无论您使用电脑、iPad还是手机，都能获得优化后的阅读体验。下拉式阅读方式在手机端的体验尤其出色。"
  },
  {
    question: "漫画内容是否有删减？",
    answer: "我们承诺提供无删减版本的韩漫内容，忠实还原原作的完整剧情和画面。部分内容可能根据相关法规进行适当的分级标注，但不会对漫画本身进行实质性删改，确保读者获得最完整的阅读体验。"
  }
];

export const testimonials = [
  {
    content: "韩漫大全是我用过最好的韩漫阅读平台，更新速度超快，画质清晰，下拉式阅读体验太棒了！每天必刷，已经推荐给身边所有喜欢韩漫的朋友了。",
    author: "漫画爱好者小陈",
    role: "忠实用户 · 使用3年"
  },
  {
    content: "作为一个重度韩漫读者，我在很多平台都看过漫画。韩漫大全的内容库是目前最全的，很多小众漫画在这里都能找到，而且都是无删减版本，真的很难得。",
    author: "漫迷达人阿杰",
    role: "VIP用户 · 使用2年"
  },
  {
    content: "下拉式阅读真的太方便了，通勤路上刷几话完全不费力。翻译质量也很高，读起来流畅自然，没有机器翻译的生硬感。感谢平台为韩漫爱好者提供这么好的服务。",
    author: "上班族小美",
    role: "活跃用户 · 使用1年"
  }
];